import React from 'react';
import { motion } from 'framer-motion';
import { clinic } from '../data/navigation';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section id="top" className="relative bg-cream" data-id="element-76" data-mp="ei1xdrp9qd0l">
      <div className="mx-auto max-w-shell px-6 pb-16 pt-20 text-center sm:pt-28 lg:px-10 lg:pb-24 lg:pt-32" data-id="element-77" data-mp="9luzmm7107tq">
        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE
      }} className="text-[0.65rem] uppercase tracking-overline text-champagne-dark" data-id="element-78" data-mp="4n1ov1j4iux9">
          Board-Certified · Miami, Florida
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: EASE
      }} className="mx-auto mt-7 max-w-4xl text-[2.4rem] font-light leading-[1.08] tracking-[-0.03em] text-ink sm:text-6xl lg:text-[4.5rem]" data-id="element-79" data-mp="s9ggdyj6ee7n">
          Personalized Plastic Surgery &amp; Med Spa in Miami
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: EASE
      }} className="mx-auto mt-8 max-w-xl text-base leading-[1.85] text-ink-soft sm:text-[1.0625rem]" data-id="element-80" data-mp="3j9agpbwlmo4m">
          Surgical artistry and advanced aesthetics under one roof — planned by Dr. Sara
          herself, guided by your anatomy, and delivered with the discretion and aftercare
          you would expect from a private practice.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.18,
        ease: EASE
      }} className="mt-11 flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-4" data-id="element-81" data-mp="2qjv4iit76p74">
          <a href="#consultation" className="w-full whitespace-nowrap bg-ink px-9 py-4 text-xs uppercase tracking-overline text-white transition-colors duration-150 ease-soft hover:bg-champagne-dark sm:w-auto" data-id="element-82" data-mp="2hl9qn0yo7yco">
            Request a Consultation
          </a>
          <a href="#procedures" className="w-full whitespace-nowrap border border-ink/25 px-9 py-4 text-xs uppercase tracking-overline text-ink transition-colors duration-150 ease-soft hover:border-champagne hover:text-champagne-dark sm:w-auto" data-id="element-83" data-mp="n98bzjimsxls">
            Before &amp; After
          </a>
        </motion.div>

        <p className="mt-8 text-sm text-ink-muted" data-id="element-84" data-mp="161jbd3e2udf5">
          Or call{' '}
          <a href={clinic.phoneHref} className="text-ink underline decoration-champagne decoration-1 underline-offset-4 transition-colors duration-150 ease-soft hover:text-champagne-dark" data-id="element-85" data-mp="112pv537eo8ba">
            {clinic.phoneDisplay}
          </a>
        </p>
      </div>

      <div className="mx-auto max-w-shell px-6 lg:px-10" data-id="element-86" data-mp="3hrd80rmt53yb">
        <motion.img initial={{
        opacity: 0,
        scale: 0.98
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.22,
        ease: EASE
      }} src="https://cdn.magicpatterns.com/patterns/generated-images/e64b2c26-858d-45e9-8572-3cc2124ab496.jpg" alt="Reception of Sara's Plastic Surgery & Med Spa in Miami, with warm neutral finishes and natural light" className="h-[46vw] max-h-[560px] min-h-[240px] w-full object-cover" data-id="element-87" data-mp="3hpsen5c8br21" />
      </div>

      <div className="h-16 bg-cream lg:h-24" data-id="element-88" data-mp="2fzj3p5pef3mf" />
    </section>;
}